import React, { useState, useEffect } from "react";

const FloatingCtaModule = () => {
  // State to control the visibility of the CTA based on scroll
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    // Function to handle scroll events
    const handleScroll = () => {
      // Check if the user has scrolled 200px or more, then hide the CTA
      if (window.scrollY > 200) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
    };

    // Add the scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  if (!isVisible) {
    return null; // Hide the component after scrolling
  }

  return (
    <div className="floating-cta-module cta-module-container fixed bottom-2 right-2 z-50 bg-white shadow-lg rounded-lg p-2 flex items-center space-x-2">
      <div className="cta-module flex items-center space-x-2">
        <div className="img-container flex-shrink-0">
          <noscript>
            <img
              width="60"
              height="57"
              src="https://s22908.pcdn.co/wp-content/uploads/2021/06/cta-module-phone-app@2x.png"
              className="attachment-full size-full"
              alt="Phone protected by ExpressVPN."
              decoding="async"
            />
          </noscript>
          <img
            width="60"
            height="57"
            src="https://s22908.pcdn.co/wp-content/uploads/2021/06/cta-module-phone-app@2x.png"
            data-src="https://s22908.pcdn.co/wp-content/uploads/2021/06/cta-module-phone-app@2x.png"
            className="attachment-full size-full lazyloaded"
            alt="Phone protected by ExpressVPN."
            decoding="async"
          />
        </div>
        <div className="cta-text text-xs">
          <h5 className="font-semibold text-gray-800">Choose PrepNexa</h5>
          <div className="button-group mt-1">
            <a
              className="btn primary-sm primary-btn-cta px-2 py-1 bg-fuchsia-800 text-white rounded-sm hover:bg-fuchsia-700 transition duration-200 text-xs"
              href="/pricing"
            >
              Get PrepNexa
            </a>
          </div>
          <p className="mt-1 text-xs text-gray-500 ">
            Start your free trial today— 
            <br></br>
            explore all the benefits risk-free!
          </p>
        </div>
      </div>
      <i className="close-popup cursor-pointer text-lg text-gray-500 hover:text-gray-700 transition duration-300 absolute top-0 right-0 mt-1 mr-1">
        &times;
      </i>
    </div>
  );
};

export default FloatingCtaModule;
